import React from 'react';
import Plans from './Plans';
import { GOLDEN_VALLEY_INTERNET } from '../data/localSeoContent';

const InternetGoldenValley: React.FC = () => (
  <Plans
    city="Golden Valley"
    heroTitle="Internet in Golden Valley, Arizona"
    heroSubtitle="Local wireless internet with WAVE Fiber Speeds for Golden Valley homes and businesses — reliable service with free installation on featured plans. Check your address to see Standard Coverage or WAVE options available where you live."
    localSeo={GOLDEN_VALLEY_INTERNET}
  />
);

export default InternetGoldenValley;
